import _					from "lodash";
import sha1 				from "sha1";

import { Server } 			from "./Server";
import Service				from "./../../Libs/Service";
import SetupSettings 		from "./../settings/settings.json";

import { Settings } 		from './Settings';
import { Version } 			from './Version';
import { Monitoring } 		from "./Monitoring";

let Asset = new Service({

	Name: "Asset",

	Events: {

		"Selected Version Changed, Selected Project Compression Data Loaded, Selected Project Compression Data Changed, Selected Version Asset Added, Selected Version Assets Changed,Selected Version Assets Restored,Selected Version Assets Deleted,Active Processes Changed:asset-compress": function () {

			if (!Version.SelectedVersion) return;

			this.selectedVersionAssets = this.getVersionAssets(Version.SelectedVersion);

			_.forEach(this.selectedVersionAssets, (value, key) => {

				if (value.cacheKey) {

					this.selectedVersionAssets[key].compressionData = this.CompressionCacheData[Version.SelectedVersion['project_id']][value.cacheKey];

				}

			});

			this.selectedVersionAssetsByType = _.groupBy(this.selectedVersionAssets, "type");

			this.selectedVersionAssetCompressionData = {};

			_.keys(this.selectedVersionAssetsByType).forEach(type => {

				let size = 0;
				let isError = false;
				let isProcessing = false;
				let isUnknown = false;

				let codenames = _.map(_.values(_.filter(this.selectedVersionAssetsByType[type], asset => asset.type !== 'image' || !asset.options.atlases || asset.options.atlases.length === 0)), 'codename');

				size = this.getSize(codenames);
				isProcessing = this.getProcessing(codenames);
				isUnknown = this.getUnknown(codenames);
				isError = this.getError(codenames);

				this.selectedVersionAssetCompressionData[type] = {
					size: size,
					isError: isError,
					isProcessing: isProcessing,
					isUnknown: isUnknown
				}

			});

			Broadcast.call("Asset Compression Data Changed");

		}

	},

	Actions: {

		"Assets": function(assetsByVersions, data) {

			_.each(assetsByVersions, (versionAssets, versionId) => {

				_.each(versionAssets, (newAsset, assetCodename) => {

					this.setAsset(parseInt(versionId), assetCodename, newAsset);

				});

				//Если установлен этот маркер - значит отправляются все ассеты указанной версии (создание новой версии)
				if (data.AssetsVersionId) {

					Broadcast.call(`Version Assets Loaded`, [versionId]);
					Broadcast.call(`Version Assets Loaded:${versionId}`);
					if ((Version.SelectedVersion?.baseVersionId || Version.SelectedVersion?.id) === parseInt(versionId)) Broadcast.call(`Selected Version Assets Loaded`);

				}

			});

			//Если установлен этот маркер - значит это первоначальное получение данных о только что впервые открытом проекте (все ассеты всех версий проекта загружаются)
			if (data.AssetsProjectId) {

				Broadcast.call(`Project Assets Loaded`, [data.AssetsProjectId]);
				Broadcast.call(`Project Assets Loaded:${data.AssetsProjectId}`);
				if ((Project.SelectedProject?.id) === parseInt(data.AssetsProjectId)) Broadcast.call(`Selected Project Assets Loaded`);

			}

			//Помечаем этим маркером первоначальную загрузку ассетов первого наблюдаемого проекта
			this.loaded = true;

		},

		"AssetsOriginal": function(assetsOriginalByVersions, data) {

			_.each(assetsOriginalByVersions, (versionAssetsOriginal, versionId) => {

				this.AssetsOriginalByVersion[versionId] = {};
				this.AssetsOriginalByVersionByCodename[versionId] = {};

				_.each(versionAssetsOriginal, (newAssetOriginal, assetCodename) => {

					this.setAssetOriginal(parseInt(versionId), assetCodename, newAssetOriginal);

				});

				//Если установлен этот маркер - значит отправляются все original ассеты указанной версии (обновление проекта из репозитория)
				if (data.AssetsVersionId) {

					Broadcast.call(`Version Assets Original Loaded`, [versionId]);
					Broadcast.call(`Version Assets Original Loaded:${versionId}`);
					if ((Version.SelectedVersion?.baseVersionId || Version.SelectedVersion?.id) === parseInt(versionId)) Broadcast.call(`Selected Version Assets Original Loaded`);

				}

			});

			//Если установлен этот маркер - значит это первоначальное получение данных о только что впервые открытом проекте (все ассеты всех версий проекта загружаются)
			if (data.AssetsProjectId) {

				Broadcast.call(`Project Assets Original Loaded`, [data.AssetsProjectId]);
				Broadcast.call(`Project Assets Original Loaded:${data.AssetsProjectId}`);
				if ((Project.SelectedProject?.id) === parseInt(data.AssetsProjectId)) Broadcast.call(`Selected Project Assets Loaded`);

			}

		},

		"ChangedAssetsData": function(changedAssetsData) {

			this.detectAssetsChanges(changedAssetsData);

		},

		"CompressionCacheSize": function(size) {

			this.CompressionCacheSize = size;

			Broadcast.call("Compression Cache Size Changed");

		},

		"ProjectCompressionCacheData": function(projectCompressionData, data) {

			this.CompressionCacheData[data.ProjectId] = projectCompressionData;

			if (Project.SelectedProject?.id === data.ProjectId) Broadcast.call("Selected Project Compression Data Loaded");

		},

		"CompressionCacheData": function(compressionData, data) {

			if (!this.CompressionCacheData[data.ProjectId]) this.CompressionCacheData[data.ProjectId] = {};
			this.CompressionCacheData[data.ProjectId][data.CacheKey] = compressionData;

			if (Project.SelectedProject?.id === data.ProjectId) Broadcast.call("Selected Project Compression Data Changed");

		}

	},

	init() {

		this.loaded = false;

		this.Assets = {};
		this.AssetsByVersion = {};
		this.AssetsByVersionByCodename = {};

		this.AssetsOriginal = {};
		this.AssetsOriginalByVersion = {};
		this.AssetsOriginalByVersionByCodename = {};

		this.atlasesColors = ['#4dbd74', '#e83e8c', '#ffc107', '#6f42c1', '#f86c6b', '#20a8d8', '#20c997'];

		this.audioInstances = {};

		this.CompressionCacheSize = 0;
		this.CompressionCacheData = {};

		window.addEventListener("message", e => {
			if (!e.data) return;

			if (e.data.setAssetsEnabledFromGame) {
				this.setAssetsEnabled(e.data.setAssetsEnabledFromGame.assets);
			}
		});

	},
	
	setAssetsEnabled(assets) {

		if (!Version || !Version.SelectedVersion) return;

		const versionId = Version.SelectedVersion.id;

		Server.sendToSocket({
			SetAssetsEnabled: {
				versionId,
				assets
			}
		});

	},

	resetAsset(assetCodename) {
		if(!Version || !Version.SelectedVersion) return;

		const versionId = Version.SelectedVersion.id;

		Server.sendToSocket({
			ResetAsset: {
				versionId,
				assetCodename
			}
		});
	},

	setAssetOriginal(versionId, assetCodename, assetOriginal) {

		this.AssetsOriginal[assetOriginal.id] = assetOriginal;

		if (!this.AssetsOriginalByVersion[assetOriginal['version_id']]) this.AssetsOriginalByVersion[assetOriginal['version_id']] = {};
		this.AssetsOriginalByVersion[assetOriginal['version_id']][assetOriginal.id] = assetOriginal;

		if (!this.AssetsOriginalByVersionByCodename[assetOriginal['version_id']]) this.AssetsOriginalByVersionByCodename[assetOriginal['version_id']] = {};
		this.AssetsOriginalByVersionByCodename[assetOriginal['version_id']][assetOriginal.codename] = assetOriginal;

	},

	setAsset(versionId, assetCodename, asset) {

		let oldAsset = this.AssetsByVersionByCodename[versionId]?.[assetCodename];

		if (asset) {

			this.Assets[asset.id] = asset;

			if (!this.AssetsByVersion[asset['version_id']]) this.AssetsByVersion[asset['version_id']] = {};
			this.AssetsByVersion[asset['version_id']][asset.id] = asset;

			if (!this.AssetsByVersionByCodename[asset['version_id']]) this.AssetsByVersionByCodename[asset['version_id']] = {};
			this.AssetsByVersionByCodename[asset['version_id']][asset.codename] = asset;

		} else {

			if (oldAsset) {

				delete this.Assets[oldAsset.id];
				if (this.AssetsByVersion[oldAsset['version_id']]) delete this.AssetsByVersion[oldAsset['version_id']][oldAsset.id];
				if (this.AssetsByVersionByCodename[oldAsset['version_id']]) delete this.AssetsByVersionByCodename[oldAsset['version_id']][oldAsset.codename];

			}

		}

	},

	//Определяем какие конкретно изменения произошли
	detectAssetsChanges(changedAssetsData) {

		const SelectedVersionAssetsChanged = [];
		const AssetsChanged = [];

		const SelectedVersionAssetsRestored = [];
		const SelectedVersionAssetsDeleted = [];

		const AssetsRestored = [];
		const AssetsDeleted = [];

		_.each(changedAssetsData, changedAssetData => {

			const versionId = changedAssetData.versionId;
			const assetCodename = changedAssetData.assetCodename;
			const oldAsset = this.AssetsByVersionByCodename[versionId]?.[assetCodename];
			const newAsset = changedAssetData.asset;

			this.setAsset(changedAssetData.versionId, changedAssetData.assetCodename, changedAssetData.asset);

			if (oldAsset) {

				if (newAsset) {

					if (newAsset.version_id === Version.SelectedVersion?.id) {

						SelectedVersionAssetsChanged.push([newAsset.version_id, newAsset.codename]);

					} else {

						AssetsChanged.push([newAsset.version_id, newAsset.codename]);

					}

				}

				//Если изменения ессета удалили (возможно reset)
				else {

					//Если это ассет текущей просматриваемой пользователем версии проекта
					if (oldAsset.version_id === Version.SelectedVersion?.id) {

						//Если ассет был в json файле настроек
						if (this.AssetsOriginalByVersionByCodename[Version.Versions[oldAsset.version_id]?.baseVersionId]?.[oldAsset.codename]) {

							SelectedVersionAssetsRestored.push([oldAsset.version_id, oldAsset.codename]);

						} else {

							SelectedVersionAssetsDeleted.push([oldAsset.version_id, oldAsset.codename]);

						}

					} else {

						//Если ассет был в json файле настроек
						if (this.AssetsOriginalByVersionByCodename[Version.Versions[oldAsset.version_id]?.baseVersionId]?.[oldAsset.codename]) {

							AssetsRestored.push(oldAsset);

						} else {

							AssetsDeleted.push(oldAsset);

						}

					}

				}

			}

			//Если такого объекта изменений ассета ещё не было на клиенте
			else {

				//Если в новых пришедших данных есть объект изменённых данных ассета
				if (newAsset) {

					//Если это ассет текущей просматриваемой пользователем версии проекта
					if (newAsset.version_id === Version.SelectedVersion?.id) {

						SelectedVersionAssetsChanged.push([newAsset.version_id, newAsset.codename]);

					} else {

						AssetsChanged.push([newAsset.version_id, newAsset.codename]);

					}

				}

				//Если изменения ассета удалили (возможно reset)
				else {

					//Тут можно ничего не делаеть. Изменений ассета и так не было, но пришло сообщение что их удалили

				}

			}
		});

		if (SelectedVersionAssetsChanged.length) Broadcast.call("Selected Version Assets Changed", SelectedVersionAssetsChanged);
		if (AssetsChanged.length) Broadcast.call("Assets Changed", AssetsChanged);

		if (SelectedVersionAssetsRestored.length) Broadcast.call("Selected Version Assets Restored", SelectedVersionAssetsRestored);
		if (SelectedVersionAssetsDeleted.length) Broadcast.call("Selected Version Assets Deleted", SelectedVersionAssetsDeleted);

		if (AssetsRestored.length) Broadcast.call("Assets Restored", AssetsRestored);
		if (AssetsDeleted.length) Broadcast.call("Assets Deleted", AssetsDeleted);
		
	},

	getAsset(version, assetCodename, withCacheKey = true) {

		//Оригинальное значение из json файла настроек (его может не быть если ассет создан в дашборде)
		let assetOriginal = this.AssetsOriginalByVersionByCodename[version.baseVersionId || version.id]?.[assetCodename];
		//Изменённые данные или данные созданные в дашборде (их может не быть если ассет был сканирован из json файла и не менялся)
		let assetChanges = this.AssetsByVersionByCodename[version.id]?.[assetCodename];

		if (!assetOriginal && !assetChanges) return null;

		let asset = {};

		if (assetOriginal) {

			_.extend(asset, _.pickBy({'publisher_id': assetOriginal['publisher_id'], 'project_id': assetOriginal['project_id'], 'version_id': assetOriginal['version_id'], originalAssetId: assetOriginal['id'], codename: assetOriginal['codename'], title: assetOriginal['title'], type: assetOriginal['type'], url: assetOriginal['url'], Tags: _.clone(assetOriginal.Tags), timestamp: assetOriginal['timestamp'], options: _.cloneDeep(assetOriginal['options']), cacheKey: assetOriginal['cacheKey']}, v => !!v));

		}

		if (assetChanges) {

			_.extend(asset, _.pickBy({'publisher_id': assetChanges['publisher_id'], 'project_id': assetChanges['project_id'], 'version_id': assetChanges['version_id'], changedAssetId: assetChanges['id'], codename: assetChanges['codename'], title: assetChanges['title'], type: assetChanges['type'], url: assetChanges['url'], timestamp: assetChanges['timestamp'], cacheKey: assetChanges['cacheKey']}, v => !!v));

			if (assetChanges.Tags['enabled'] && asset.Tags) delete asset.Tags.disabled;

			asset.Tags = _.extend(asset.Tags || {}, assetChanges.Tags);
			asset.options = _.extend(asset.options || {}, assetChanges.options);

		}

		//Если у ассета нет изменений - берётся оригинальная запись с id базовой версией, но код рассчитывает на то, что в ассете всегда будет реальный version_id той версии к которой принадлежит ассет
		asset['version_id'] = version.id;

		asset.isRandom = this.isRandomAsset(asset);
		asset.isChanged = this.isChangedAsset(version, assetCodename);

		asset.timestamp = new Date(asset.timestamp);

		asset.isPNG = (asset.type === 'image' && _.endsWith(asset.url, '.png'));
		asset.isJPG = (asset.type === 'image' && _.endsWith(asset.url, '.jpg'));
		asset.isGIF = (asset.type === 'image' && _.endsWith(asset.url, '.gif'));
		asset.isSVG = (asset.type === 'image' && _.endsWith(asset.url, '.svg'));
		asset.isHDR = (asset.type === 'image' && _.endsWith(asset.url, '.hdr'));

		if (!asset.options.playOnEvents) asset.options.playOnEvents = [];
		if (!asset.options.stopOnEvents) asset.options.stopOnEvents = [];
		if (!asset.options.volume) asset.options.volume = 1;

		asset.hasPlayEvents = asset.options.playOnEvents.length > 0;
		asset.hasStopEvents = asset.options.stopOnEvents.length > 0;
		asset.hasAtlas = asset.options.atlases && asset.options.atlases.length > 0;
		asset.hasCompression = "compression" in asset.options;

		//06.11.2025 Фикс для старого шаблона. Без него текстовые ассеты и шрифты замененные до перехода на -old домен загружаются с dashboard.mraid.io и возвращают 404
		if (location.hostname === 'dashboard-old.mraid.io' && typeof asset.url === 'string') asset.url = asset.url.replace('/dashboard.mraid.io/', `/${SetupSettings.domain}/`);

		if (withCacheKey) asset.cacheKey = this.getAssetCompressionCacheFileName(Project.Projects[version['project_id']], version, asset);

		return asset;

	},

	getAssetCompressionCacheFileName(project, version, asset, ext = '') {

		if (!asset) return null;

		let compression = this.getMergedAssetCompression(asset);

		let compression_string = compression;

		//Предусматриваем и очищенный для релиза ассет и не очищенный
		let assetOptions = asset.options || asset;

		if (asset.type === 'atlas') compression_string = `${compression}-${assetOptions.atlasScale || 1}-${assetOptions.atlasShapePadding || 0}-${assetOptions.atlasExtrude || 1}-${assetOptions.atlasTrimMode || 'Trim'}-rotation-${!!assetOptions.atlasRotation}-${assetOptions.atlasFormat || 'png'}-${assetOptions.atlasOpt || 'RGBA8888'}-${assetOptions.atlasDitherType || 'FloydSteinbergAlpha'}-tinypng-${!!assetOptions.atlasTinyPng}-files-${sha1(this.getAtlasImagesKeys(project, version, asset).join(','))}`;
		else if (asset.type === 'image') compression_string = `${compression}-tinypng-${assetOptions.tinyPng !== false}`;
		else if (asset.type === 'sound') compression_string = `${assetOptions.bitrate || 64}kbps`;
		else if (asset.type === 'video') compression_string = `video-${assetOptions.jsmpeg ? 'jsmpeg-' : ''}${assetOptions.videoBitrate || 2048}kbps-audio-${assetOptions.audioBitrate || 128}kbps-stereo-${assetOptions.audioStereo !== false}`;

		if (project.type === 'banner') compression_string = version.id + '-' + compression_string;

		return `${project.id}-${compression_string}-${sha1(asset.url + (asset.size || 0))}${ext ? '.' + ext : ''}`;

	},

	getMergedAssetCompression(asset) {

		//Для изображений находящихся в атласах возвращаем 100% качество
		if (asset.options && asset.options.atlases && asset.options.atlases.length > 0) return 1;

		//Для ассетов которые не сжимаются возвращаем 100% качество
		if (!(['image', 'atlas'].includes(asset.type))) return 1;

		if (asset.options && asset.options.compression) return asset.options.compression;

		//Для тех кто сжимается возвращаем 80% по умолчанию
		return asset.compression || 0.8;

	},

	getAtlasImagesKeys(project, version, atlasAsset) {

		let keys = [];

		let assets = this.getVersionAssets(version, false);

		_.each(assets, asset => {

			if (asset.type === 'image' && _.includes(asset.options.atlases || [], atlasAsset.codename)) keys.push(this.getAssetCompressionCacheFileName(project, version, asset, ''));

		});

		keys.sort();

		return keys;

	},

	getVersionAssets(version, withCacheKey = true) {

		if (!version) return {};

		let assetCodenames = _.uniq(_.keys(this.AssetsOriginalByVersionByCodename[version.baseVersionId || version.id]).concat(_.keys(this.AssetsByVersionByCodename[version.id])));

		let assets = {};

		_.each(assetCodenames, assetCodename => {

			assets[assetCodename] = this.getAsset(version, assetCodename, withCacheKey);

		});

		let endCardVersion = EndCard.getEndCardVersion(Project.Projects[version['project_id']], version);

		if (endCardVersion) {

			let endCardAssets = this.getVersionAssets(endCardVersion, withCacheKey);

			_.each(endCardAssets, (asset, assetCodename) => {

				if (assets[assetCodename]) console.warn(`EndCard Asset conflict! Playable already have asset with codename "${assetCodename}"`);

				assets[assetCodename] = asset;

			});

		}

		return assets;

	},

	cleanVersionAssets(versionAssets) {

		let result = {};

		_.each(versionAssets, asset => {

			let mergedAsset = this.getMergedAsset(asset);

			if (mergedAsset) result[asset.codename] = mergedAsset;

		});

		return result;

	},

	getMergedAsset(asset, forThePreview = false) {

		//!!!Похожий код на серверной стороне есть - меняя что-то тут наверняка нужно изменить и на клиенте

		if (!asset) return null;

		//Не добавляем отменённые ассеты
		if (asset.Tags.disabled) return null;

		// ### Не добавляем атласы вообще если указано forThePreview (будут добавляться отдельные картинки)
		// Настройки ассетов влияющие на анимации нужно отправлять во фрейм всё-таки.
		// if (asset.type === 'atlas' && forThePreview) return null;

		//Не добавляем изображения находящиеся в атласах
		if (asset.type === 'image' && !forThePreview && asset.options.atlases && asset.options.atlases.length > 0) return null;

		//Временно перебиваем здесь качество на high - так как сжатие этого ассета будет производиться теперь по новому (без low medium) и не нужно менять путь на клиенте
		//2020.02.08 quality: 'high' нужно для поддержки старых игр
		let data = _.extend({codename: asset.codename, type: asset.type, url: asset.url, timestamp: asset.timestamp, quality: 'high'}, asset.options);

		//Заменяем урл чтобы сервер выдавал сжатые ассеты в зависимости от настроек и выдавал атласы изменённые в дашборде
		if (_.includes(['image', 'atlas', 'sound', 'video'], asset.type)) data["url"] = this.getAssetActualUrl(asset, {jsmpeg: asset.options.jsmpeg});

		/*if (asset.type === 'atlas') {

			//Устанавливаем раздельно json и url для загрузки изображения
			data.json = asset.json;
			data.image = this.getAssetActualUrl(asset, {imagesForAtlases: true});
			data.image = data.image.substr(data.image.lastIndexOf('/') + 1);

		}*/

		return data;

	},

	getMergedAssetCodename(asset) {

		let codename = asset.codename;

		//Нужно вернуть название пропаршеному ассету такое какое было в атласе если этот ассет достали из атласа
		if (asset.type === 'image' && asset.options.atlases && asset.options.atlases.length > 0 && codename.indexOf('|') > 0) codename = codename.substr(codename.lastIndexOf('|') + 1);

		return codename;

	},

	//Для случайных ассетов создаём все возможные варианты в Assets
	expandRandomAssets(settings, assets) {

		_.each(assets, (asset, name) => {

			if (this.isRandomAsset(asset)) {

				if (asset["values"]) {

					this.expandRandomSettingsAsset(assets, name, asset, asset["values"]);

				} else if (asset["valueFrom"]) {

					if (asset["valueFrom"] in settings) {

						this.expandRandomAsset(assets, name, asset, settings[asset["valueFrom"]]["values"]);

					} else if (asset["valueFrom"] in assets) {

						this.expandRandomAsset(assets, name, asset, assets[asset["valueFrom"]]["values"]);

					}

				}

				delete assets[name];

			}

		});

		return assets;

	},

	//Для случайного ассета создаём все возможные варианты в Assets
	expandRandomAsset(assets, name, asset, values) {

		for (let i=0; i<values.length; i++) {

			let new_asset = _.cloneDeep(asset);

			//По этим полям определяется что ассет рандомный
			//Так как новый ассет уже не рандомный - нужно их удалить
			//Дальше есть проверка на эти поля и код сработает неверно если не удалить
			delete new_asset["values"];
			delete new_asset["valueFrom"];

			new_asset["url"] = asset["url"].replace("?", values[i]);

			assets[name + '-' + values[i]] = new_asset;

		}

	},

	isRandomAsset(asset) {

		return asset["url"] && asset["url"].indexOf('?') > -1 && asset.type === 'image';

	},

	isChangedAsset(version, assetCodename) {

		return !!(this.AssetsByVersionByCodename[version?.id]?.[assetCodename]);

	},

	downloadAsset(asset) {

		let url = Asset.getAssetActualUrl(asset, {addTimestamp: true, imagesForAtlases: true});

		let xhr = new XMLHttpRequest();
		xhr.open("GET", url, true);
		xhr.responseType = "blob";
		xhr.withCredentials = true;
		xhr.onload = function(){
			let urlCreator = window.URL || window.webkitURL;
			let imageUrl = urlCreator.createObjectURL(this.response);
			let tag = document.createElement('a');
			tag.href = imageUrl;
			tag.download = asset.codename;
			document.body.appendChild(tag);
			tag.click();
			document.body.removeChild(tag);
		};
		xhr.send();

	},

	uploadAsset(type, next) {

		let input = document.createElement('input');
		input.type = 'file';
		input.style.position = 'absolute';
		input.style.left = '0';
		input.style.top = '0';
		input.style.transform = 'scale(0.1)';
		input.style.visibility = 'hidden';
		document.body.appendChild(input);

		if (type === 'image') input.accept = "image/png, image/jpeg, image/gif, image/svg+xml";
		else if (type === 'video') input.accept = "video/mp4";
		else if (type === 'sound') input.accept = "audio/mpeg";
		else input.accept = type;

		input.addEventListener('change', e => {

			next(e.target.files[0]);

			document.body.removeChild(input);

		});

		input.addEventListener('blur', e => {

			document.body.removeChild(input);

		});

		input.click();

	},

	addAsset(assets_config, file) {

		let formData = new FormData();

		formData.append("versionId", Version.SelectedVersion.id);
		formData.append("assetType", assets_config.type);
		formData.append("file", file);

		let url = 'http://' + SetupSettings["domain"] + '/asset/add';
		if (location.protocol === 'https:') url = 'https://' + SetupSettings["domain"] + '/asset/add';

		let xhr = new XMLHttpRequest();

		xhr.withCredentials = true;

		xhr.open("POST", url);

		xhr.upload.onprogress = function(e) {

			if (e.lengthComputable) {

				assets_config.uploadProgress = e.loaded / e.total;
				Broadcast.call('Asset Upload Progress', [assets_config]);

			}

		};

		xhr.upload.onloadstart = function(e) {

			assets_config.isUploading = true;
			Broadcast.call('Asset Upload Progress', [assets_config]);

		};

		xhr.upload.onloadend = function(e) {

			assets_config.isUploading = false;
			Broadcast.call('Asset Upload Progress', [assets_config]);

		};

		xhr.send(formData);

	},

	createAtlas() {

		Server.sendToSocket({
			CreateAtlas: Version.SelectedVersion.id
		});

	},

	getAtlasColor(asset) {

		if (!asset) return null;

		return this.atlasesColors[asset.options.atlasColor - 1];

	},

	replaceAsset(asset, file) {

		let formData = new FormData();

		formData.append("versionId", asset['version_id']);
		formData.append("assetCodename", asset['codename']);
		formData.append("file", file);

		let url = 'http://' + SetupSettings["domain"] + '/asset/replace';
		if (location.protocol === 'https:') url = 'https://' + SetupSettings["domain"] + '/asset/replace';

		let xhr = new XMLHttpRequest();

		xhr.withCredentials = true;

		xhr.open("POST", url);

		xhr.upload.onprogress = function(e) {

			if (e.lengthComputable) {

				asset.uploadProgress = e.loaded / e.total;
				Broadcast.call('Asset Upload Progress', [asset]);

			}

		};

		xhr.upload.onloadstart = function(e) {

			asset.isUploading = true;
			Broadcast.call('Asset Upload Progress', [asset]);

		};

		xhr.upload.onloadend = function(e) {

			asset.isUploading = false;
			Broadcast.call('Asset Upload Progress', [asset]);

		};

		xhr.send(formData);

	},

	uploadIntoAtlas(asset, file) {

		let formData = new FormData();

		formData.append("versionId", asset['version_id']);
		formData.append("assetCodename", asset['codename']);
		formData.append("file", file);

		let url = 'http://' + SetupSettings["domain"] + '/asset/uploadIntoAtlas';
		if (location.protocol === 'https:') url = 'https://' + SetupSettings["domain"] + '/asset/uploadIntoAtlas';

		let xhr = new XMLHttpRequest();

		xhr.withCredentials = true;

		xhr.open("POST", url);

		xhr.upload.onprogress = function(e) {

			if (e.lengthComputable) {

				asset.uploadProgress = e.loaded / e.total;
				Broadcast.call('Asset Upload Progress', [asset]);

			}

		};

		xhr.upload.onloadstart = function(e) {

			asset.isUploading = true;
			Broadcast.call('Asset Upload Progress', [asset]);

		};

		xhr.upload.onloadend = function(e) {

			asset.isUploading = false;
			Broadcast.call('Asset Upload Progress', [asset]);

		};

		xhr.send(formData);

	},

	setAssetProperty(asset, property_name, value, delay = 500) {

		Server.sendWithTimeout({
			SetAssetProperty: {
				versionId: asset['version_id'],
				assetCodename: asset.codename,
				propertyName: property_name,
				propertyValue: value
			}
		}, `${asset['version_id']}-${asset.codename}-${property_name}`, delay);

	},

	compressAssets(versionId, assetCodenames) {

		Server.sendToSocket({
			CompressAssets: {
				versionId: versionId,
				assetCodenames: assetCodenames
			}
		});

	},

	getAssetActualUrl(asset, options = {}) {

		if (asset.type === 'image' || asset.type === 'atlas' || asset.type === 'sound' || asset.type === 'video') {

			let url = `${location.protocol}//${SetupSettings["domain"]}/asset/get/${asset['version_id']}/${asset.codename}`;

			if (asset.type === 'image') {

				if (asset.isPNG) url += '.png';
				if (asset.isJPG) url += '.jpg';
				if (asset.isGIF) url += '.gif';
				if (asset.isSVG) url += '.svg';
				if (asset.isHDR) url += '.hdr';

			}

			else if (asset.type === 'video') {

				//2020.11.08 - .ts in the end is not worked - because Creative Template replaces only .mp4 on .ts and .mp3
				//if (options.jsmpeg) url += '.ts';
				//else url += '.mp4';

				url += '.mp4';

			}

			else if (asset.type === 'atlas') {

				if (options.imagesForAtlases) url += '.' + asset.options.atlasFormat;
				else url += '.json';

			}

			else if (asset.type === 'sound') {

				if (url.indexOf('{ogg,mp3}') >= 0) url = url.replace('{ogg,mp3}', 'mp3');
				else url += '.mp3';

			}

			const params = {};
			if (options.addTimestamp) params.v = asset.timestamp.getTime();
			if (options.preview) params.cache = this.getAssetCompressionCacheFileName(Project.Projects[asset["project_id"]], Version.Versions[asset["version_id"]], asset);

			if (Object.keys(params).length) {
				url += '?' + new URLSearchParams(params).toString();
			}

			return url;

		} else {

			let url = asset["new_url"] || asset.url;

			if (url.indexOf('http') !== 0 && url.indexOf('data:') !== 0) url = Settings.getCurrentVersionAssetsPath() + url;

			url += '?v=' + asset.timestamp.getTime();

			return url;

		}

	},

	getSize(assetCodenames) {

		let size = 0;

		_.each(assetCodenames, assetCodename => {

			let compressionData = this.selectedVersionAssets[assetCodename].compressionData;

			let version = Version.SelectedVersion;
			if (!version) return {size: null};

			let asset = this.selectedVersionAssets[assetCodename];

			if (!asset.Tags.disabled) {
				if (compressionData && !compressionData.error && compressionData.size) size += compressionData.size;
			}

		});

		return size;

	},

	getCompressionData(assetCodename) {

		let version = Version.SelectedVersion;
		if (!version) return {size: null};

		let project = Project.Projects[version['project_id']];
		let asset = this.getAsset(version, assetCodename);

		if (!asset) return null;

		let cacheKey = this.getAssetCompressionCacheFileName(project, version, asset);

		return this.CompressionCacheData[version['project_id']][cacheKey];

	},

	getProcessing(assetCodenames) {

		let is_processing = false;

		_.each(assetCodenames, assetCodename => {

			let cacheKey = this.selectedVersionAssets[assetCodename].cacheKey;

			if (Monitoring.activeProcesses['asset-compress'][cacheKey]) is_processing = true;

		});

		return is_processing;

	},

	getCacheKey(assetCodename) {

		let version = Version.SelectedVersion;
		if (!version) return '';

		let project = Project.Projects[version['project_id']];
		let asset = this.getAsset(version, assetCodename);

		return this.getAssetCompressionCacheFileName(project, version, asset);

	},

	getUnknown(assetCodenames) {

		let is_unknown = false;

		_.each(assetCodenames, assetCodename => {

			let compressionData = this.selectedVersionAssets[assetCodename].compressionData;

			if (!compressionData) is_unknown = true;

		});

		return is_unknown;

	},

	getError(assetCodenames) {

		let is_error = false;

		_.each(assetCodenames, assetCodename => {

			let compressionData = this.selectedVersionAssets[assetCodename].compressionData;

			if (compressionData && compressionData.error) is_error = compressionData.error;

		});

		return is_error;

	}

});

//Делаем объект синглтоном чтобы при импортах возвращался тот же самый экземпляр
if (window.Asset) Asset = window.Asset;
else window.Asset = Asset;

export { Asset }

